<template>
  <el-tabs tab-position="left" v-model="tabActive">
    <el-tab-pane label="LuckyWheel" name="LuckyWheel">
      <DetailTabData :data="allData.LuckyWheel" :on-change="onChangeDataLb"/>
    </el-tab-pane>
<!--    <el-tab-pane label="NonStopOffer" name="NonStopOffer">-->
<!--      <DetailTabData :data="allData.NonStopOffer" :on-change="onChangeDataLb"/>-->
<!--    </el-tab-pane>-->
    <el-tab-pane label="Recharge" name="Recharge">
      <DetailTabData :data="allData.Recharge" :on-change="onChangeDataLb"/>
    </el-tab-pane>
<!--    <el-tab-pane label="Wheel" name="Wheel">-->
<!--      <DetailTabData :data="allData.Wheel" :on-change="onChangeDataLb"/>-->
<!--    </el-tab-pane>-->
  </el-tabs>
</template>

<script>

import DetailTabData from "./DetailTabData.vue"

function noop() {}

export default {
  name: "event",
  components: {
    DetailTabData,
  },
  props: {
    allData : {},
    onChange: {
      type: Function,
      default: noop
    },
  },
  data: () => {
    return {
      tabActive: "LuckyWheel",
    }
  },
  methods: {
    onChangeDataLb(typeEvent) {
      //console.log(`tabEdit onChangeDataEvent ${typeEvent} -> ${this.allData[typeEvent].IsActive}`);
    },
  }
};

</script>